module.exports = __webpack_public_path__ + "static/media/transitional.790ccc96.svg";